
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-db586e1a\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/purchase.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./orderDetails.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-db586e1a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./orderDetails.vue"),
  /* scopeId */
  "data-v-db586e1a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/ecommerce/orderDetails.vue
// module id = 1768
// module chunks = 0